import http from "@/api/http";

export const solutionInfo = (id) => http.get('/mgm/solution/' + id);
